import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";

export interface IPlanningDayButtonContext {
    isSelected: boolean;
    hasStatus: boolean;
    isCompletly: boolean;
    statusLoading: boolean;
    statusAvailable: boolean;
}

@Component({
    selector: 'planning-day-button',
    templateUrl: './planning-day-button.component.html',
    styleUrls: ['./planning-day-button.component.scss']
})
export class PlanningDayButtonComponent {
    
    @Input() dayContext: IPlanningDayButtonContext;

    @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

    getDayStatusClass(): string {
        if (!this.dayContext.hasStatus) {
            return 'default-day';
        }

        let className = this.dayContext.statusLoading ? '' : this.dayContext.statusAvailable ? 'green-day' : 'red-day';

        if (this.dayContext.isSelected) {
            className += ' selected-green-day';
        }

        return className;
    }
}